import React, { useState, useEffect } from 'react';
import axios from 'axios';
import Loader from '../../Common/Loader';
import constants from '../../../constants';
import { cookieStorageUtility } from '../../../utils/utilityFunctions';
import { Link, useNavigate } from 'react-router-dom';

const { serverUrl, ENCRYPTOR_KEY } = constants;
const authUserId = cookieStorageUtility.fetch('auth_user_id');
const encryptedToken = cookieStorageUtility.fetch('encrypted_' + ENCRYPTOR_KEY + '_token');

const AllChannelList = () => {
  const navigate = useNavigate();
  const [list, setList] = useState([]);
  const [showUILoader, setShowUILoader] = useState(false);
  const [flag, setFlag] = useState(false);
  const [type, setType] = useState('error');
  const [message, setMessage] = useState('');

  useEffect(() => {
    getAllChannelList();
    // eslint-disable-next-line
  }, []);

  const getAllChannelList = () => {
    const hotelId = cookieStorageUtility.fetch('hotelId');
    setShowUILoader(true);
    axios(serverUrl + 'channel/getallchannels', {
      method: 'POST',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        token: btoa(authUserId + '|' + encryptedToken)
      },
      data: { hotelId }
    })
      .then(response => {
        if (response.data.responseCode) {
          setList(response.data.data);
        } else {
          showMessage('error', response.data.message);
        }
        setShowUILoader(false);
      })
      .catch(error => {
        console.log(error);
        setShowUILoader(false);
      });
  };

  const showMessage = (type, msg) => {
    setFlag(true);
    setType(type);
    setMessage(msg);
    setTimeout(() => setFlag(false), 5000);
  };

  const manageChannel = (channelData) => {
    navigate('/channelmanager/mychannel/channeldetails/' + btoa(JSON.stringify(channelData)));
  };

  const renderChannelList = () => {
    if (Object.keys(list).length > 0) {
      return Object.keys(list).map(id => {
        var data = list[id];
        return (
          <div key={id} className="cover border_b_1 border_color_1">
            <div className="row no-gutters">
              <div className="col-xs-12 col-md-2">
                <div className="pad_lft_rht10 pad_top_bot20 ovr listlogo">
                  <img src={data.logoPath} className="images" />
                </div>
              </div>
              <div className="col-xs-12 col-md-8">
                <div className="pad_lft_rht10 pad_top_bot20 ovr">
                  <a className="disblock margtop5 color6_1" onClick={() => manageChannel(data)}>
                    {data.ota_name}
                  </a>
                  <div id="readmore" className="ovr margtop5">
                    {data.ota_desc}
                  </div>
                </div>
              </div>
              {data.connected === true
                ? <div className="col-xs-12 col-md-2">
                  <div className="pad_lft_rht10 pad_top_bot20 ovr">
                    <a className="btn1 disblock pad_top_bot7 tc" onClick={() => manageChannel(data)}>
                      Details
                    </a>
                  </div>
                </div>
                : <div className="col-xs-12 col-md-2">
                  <div className="pad_lft_rht10 pad_top_bot20 ovr">
                    <a className="btn1 disblock pad_top_bot7 tc" onClick={() => manageChannel(data)}>
                        Connect
                    </a>
                  </div>
                </div>}
            </div>
          </div>
        );
      });
    }
  };

  return (
    <React.Fragment>
      {showUILoader ? <Loader /> : ''}
      <div className="container_fluid topheading pad_lft_rht25 pad_top_bot15 text-start">
        <div className="row">
          <div className="col-xs">
            <div className="d-full-height justify-content-center fnt18 tu">All Channel</div>
          </div>
        </div>
      </div>
      {flag ? (
        <div
          className={`alert_col posfixed pad10 tc fnt16 bld ${type === 'error' ? 'danger' : 'success'}`}
        >
          {message}
        </div>
      ) : ''}
      <div className="container pad_top_bot10 ng-scop text-start">
        <div className="container-fluid pad_lft_rht15">
          <div className="wrapper border_t_1 border_l_1 border_r_1 border_color_1">
            <div className="cover border_b_1 border_color_1 listheading">
              <div className="row no-gutters color2_2 fnt14">
                <div className="col-xs-12 col-md-2 border_r_1 border_color_1">
                  <div className="pad_lft_rht10 pad_top_bot10 tc ng-binding">Logo</div>
                </div>
                <div className="col-xs-12 col-md-8 border_r_1 border_color_1">
                  <div className="pad_lft_rht10 pad_top_bot10 ng-binding">Name and Description</div>
                </div>
                <div className="col-xs-12 col-md-2">
                  <div className="pad_lft_rht10 pad_top_bot10 tc ng-binding">Actions</div>
                </div>
              </div>
            </div>
            <div className="cover color2_2 fnt14">{renderChannelList()}</div>
          </div>
        </div>
      </div>
    </React.Fragment>
  );
};

export default AllChannelList;
